// extracted by mini-css-extract-plugin
export var addButton = "_oj-0";
export var border = "_oj-8";
export var check = "_oj-h";
export var danger = "_oj-6";
export var dropdownContainer = "_oj-1";
export var editModalBody = "_oj-j";
export var footerContainer = "_oj-i";
export var fullWidth = "_oj-a";
export var hide = "_oj-9";
export var icon = "_oj-3";
export var input = "_oj-7";
export var inputFlex = "_oj-b";
export var inputWrapper = "_oj-c";
export var manualFocus = "_oj-5";
export var optionButton = "_oj-4";
export var pillWrapper = "_oj-e";
export var pointer = "_oj-2";
export var showOverflow = "_oj-f";
export var tagsFlex = "_oj-d";
export var xButton = "_oj-g";